import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .tableWapper': {
        width: '100%',
        height: '600px',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
            '& .cell': {
                width: '16%',
            },
        }
    },
    '& .search': {
        width: '210px',
        height: '41px',
        color: '#58727C',
        backgroundColor: '#fff',
        borderRadius: 4,
        border: '1px solid #ced4da',
        marginBottom: '10px',
        '& .search-icon': {
            padding: '0 10px',
        },
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .crtTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
});